<template>
    <div class="table-appaltante card p-3">
      <TableView
        :columns="columns"
        :items="questions"
        :pagination="pagination"
        :sort-field="sortField"
        :sort-direction="sortDirection"
        @page-change="$emit('page-change', $event)"
        @sort="$emit('sort', $event)"
      >
        <template #id="{ item }">{{ item.id }}</template>
        <template #created_at="{ item }">{{ formatDate(item.created_at) }}</template>
        <template #topics="{ item }">
          <div v-for="t in item.topics" :key="t.id" class="text-truncate-ellipsis" :title="t.title">{{ t.title }}</div>
        </template>
        <template #object="{ item }">{{ item.object }}</template>
        <template #state_id="{ item }">
          <div class="text-center">
            <i
              v-for="(cfg, key) in stateIcons"
              :key="key"
              class="bi mx-1"
              :class="cfg.icon"
              :style="{ color: item.state_id === key ? cfg.activeColor : cfg.inactiveColor, fontSize: '1.4rem' }"
            />
          </div>
        </template>
        <template #actions="{ item }">
          <button class="btn btn-sm btn-outline-secondary" @click="$emit('open-detail', item)" title="Dettaglio quesito">
            <i class="bi bi-search"></i>
          </button>
        </template>
        <template #empty>Nessun elemento trovato.</template>
      </TableView>
    </div>
  </template>
  
  <script>
  import TableView from '../../../../components/common/TableView.vue';
  export default {
    name: 'AppaltanteTable',
    components: { TableView },
    props: ['questions', 'pagination', 'sortField', 'sortDirection', 'stateIcons'],
    data() {
      return {
        columns: [
          { key: 'id', label: 'Codice', sortable: true },
          { key: 'created_at', label: 'Data', sortable: true },
          { key: 'topics', label: 'Argomenti' },
          { key: 'object', label: 'Oggetto', sortable: true },
          { key: 'state_id', label: 'Iter' }
        ]
      };
    },
    methods: {
      formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT');
      }
    }
  };
  </script>
  
  <style scoped>
  .table-appaltante table th:nth-child(1) { width: 5%; }
  .table-appaltante table th:nth-child(2) { width: 10%; }
  .table-appaltante table th:nth-child(3) { width: 25%; }
  .table-appaltante table th:nth-child(4) { width: 40%; }
  .table-appaltante table th:nth-child(5) { width: 15%; }
  </style>
  